// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"195":"68407d85","213":"4270380a","581":"f6484e3e","667":"7d6a52f6","875":"02ec6479"}[chunkId] + ".chunk.js";
};